<template>
  <v-container class="no-margins">

    <div class="v-step-0 v-step-1 v-step-2 v-step-12 v-step-21 v-step-27">
      <h1>{{ $t("welcome.hello") }} {{ this.currentUser.firstName }}!</h1>
      <h6 v-if="isApprentice" class="mt-n4 mb-6">{{ subTitle }}</h6>
    </div>

    <template v-if="shouldReadInstructions && isInstructor(0)">
      <MessageBox class="my-6" type="warning">
        <h6>{{ $t("settings.no-readInstructions-mb-title") }}</h6>
        <p v-html="$t('settings.no-readInstructions-mb-text')"></p>
    </MessageBox>
    </template>
    <!-- <div v-if="basicsIsLoaded && (isInstructor(0) || isApprentice)"> -->
    <MessageBox type="alert" class="mb-8" v-if="showOrderWarning && (isDistanceEducationAdministrator(0) ||
                  isDepartmentAdministrator(0) || isAdministrator)">
      <h5>{{ $t("order.info.daysWarning-title") }}</h5>
        <p>
          {{ $t("order.info.daysWarning-text2") }}
        </p>
    </MessageBox>

    <Byn2Import />

    <div v-if="filteredInstructorOptions.length">
      <h4>{{ $t("welcome.sub-title3") }}</h4>
    </div>

    <EbookList v-if="isApprentice && this.isInstructor(0)!=true && currentUser.books.length>0" :ebooks="currentUser.books" class="mb-4"></EbookList>

    <!-- IF apprentice has QT -->
    <ActionButton 
      actionIcon="$sl-stairs-ascend" 
      v-if="hasQualificationTime"
      @click="
        $nextTick(() => {
          $router.push({ name: 'PersonQualifyingTime', params: { id: currentUser.id } });
        })
      "
      >
      {{ $t('labels.my-qualifying-time') }}
    </ActionButton>
    
    <!-- IF apprentice has certificates -->
    <ActionButton 
      class="pt-0 mt-4 mb-4 v-step-26" 
      actionIcon="$sl-trade-certificate" 
      v-if="hasCertificates"
      @click="
        $nextTick(() => {
          $router.push({ name: 'PersonQualifications' });
        })
      "
      >
      {{ $t('labels.qualifications') }}
    </ActionButton>

    <template>
      <ActionButton
        class="pt-0 mt-4 v-step-26"
        :class="{ 'mt-10' : hasCertificates }"
        actionIcon="$sl-apprentice-application"
        @click="
          $nextTick(() => {
            $router.push({ name: 'ApplicationStart', params: { setStep: 0 } });
          })
        "
        :badge="companyApplicationTotal"
        v-if="isLoggedIn && isRegistered && !isCompanyUser(0)"
        >{{ $t("labels.application") }}</ActionButton
      >
    </template>

    <template v-if="isInstructor(0)">
      <ButtonArray text="left" :options="filteredInstructorOptions" />
      <v-spacer class="pb-8"></v-spacer>
    </template>

    <template v-if="currentUser.books.length && isInstructor(0)==false && (isCompanyEducationResponsible(0) || isDistanceEducationAdministrator(0) || isAdministrator)">
      <ActionButton
        class="mt-4 left"
        actionIcon="$sl-ebook"
        @click="
          $nextTick(() => {
            $router.push({name: 'InstructorEbooks', params: {id: currentUser.id}})
          })
        "
        >{{ $t('labels.e-book') }}</ActionButton
      >
      <v-spacer class="pb-8"></v-spacer>
    </template>
<!-- <template v-if="basicsIsLoaded && isCompanyUser(0)"> -->
    <template v-if="isCompanyUser(0)">
      <h4 class="pb-1 mt-10">{{ $t("labels.company-title") }}</h4>

      <v-expansion-panels :value="0" class="pb-0 mt-4">
        <v-expansion-panel v-for="(employment, i) in currentUser.employments" :key="i">
          <v-expansion-panel-header expand-icon="$sl-arrow-down">
            <div>
              <h5 class="subtitle-1">
                {{ employment.company ? employment.company.name : "Företaget" }}
              </h5>
              <span class="subtitle-2">{{
                employment.company.organizationalNumber | orgno
              }}</span>
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content class="mb-2">
            <div class="v-step-4 v-step-24">
              <ActionButton
                v-if="isCompanyUser(employment.companyId)"
                actionIcon="$sl-workplace"
                @click="
                  $nextTick(() => {
                    $router.push({
                      name: 'CompanyWorkplaces',
                      params: { id: employment.companyId },
                    });
                  })
                "
                >{{ $t("labels.workplaces") }}</ActionButton
              >
            </div>
            <div class="v-step-5">
              <ActionButton
                v-if="
                  (isAdministrator || isDepartmentAdministrator(employment.companyId)) &&
                  hasDepartments(employment.companyId)
                "
                class="mt-4 left"
                actionIcon="$sl-departments"
                @click="
                  $nextTick(() => {
                    $router.push({
                      name: 'CompanyDepartments',
                      params: { id: employment.companyId },
                    });
                  })
                "
                >{{ $t("company.sections") }}</ActionButton
              >
            </div>
            <div class="">
              <ActionButton
                v-if="isAdministrator || isDepartmentAdministrator(employment.companyId) ||
                  isDistanceEducationAdministrator(employment.companyId)"
                class="mt-4 left"
                actionIcon="$sl-invitation"
                @click="
                  $nextTick(() => {
                    $router.push({
                      name: 'CompanyOrderCardStart',
                      params: { id: employment.companyId },
                    });
                  })
                "
                >{{ $t('labels.person-orders-machine') }}</ActionButton
              >
            </div>
            <div class="v-step-11">
              <ActionButton
                v-if="
                  isDistanceEducationAdministrator(employment.companyId) ||
                  isDepartmentAdministrator(employment.companyId) ||
                  isAdministrator
                "
                class="mt-4 left"
                :badge="toConfirm[employment.companyId] || 0"
                actionIcon="$sl-approve-distance-order"
                @click="
                  $nextTick(() => {
                    $router.push({
                      name: 'CompanyDistanceOrders',
                      params: { companyId: employment.companyId },
                    });
                  })
                "
                >{{ $t("labels.approve-distance-orders") }}</ActionButton
              >
            </div>
            <!-- To fix v tour stepper -->
            <div class="">
              <ActionButton
                v-if="
                  isAdministrator ||
                  isDepartmentAdministrator(employment.companyId) ||
                  isDistanceEducationAdministrator(employment.companyId)
                "
                class="mt-4 left"
                actionIcon="$sl-single-neutral-actions-check"
                @click="
                  $nextTick(() => {
                    $router.push({
                      name: 'CompanyExemptions',
                      params: { id: employment.companyId },
                    });
                  })
                "
                >{{ $t("labels.exemptions") }}</ActionButton
              >
            </div>

            <div class="v-step-9">
              <ActionButton
                v-if="
                  isDistanceEducationAdministrator(employment.companyId) ||
                  isAdministrator ||
                  isDepartmentAdministrator(employment.companyId)
                "
                class="mt-4 left"
                actionIcon="$sl-instructor"
                @click="
                  $nextTick(() => {
                    $router.push({
                      name: 'CompanyInstructors',
                      params: { id: employment.companyId },
                    });
                  })
                "
                >{{ $t("labels.instructors") }}</ActionButton
              >
            </div>
            <div class="v-step-10">
              <ActionButton
                v-if="
                  isCompanyEducationResponsible(employment.companyId) ||
                  isDistanceEducationAdministrator(employment.companyId) ||
                  isDepartmentAdministrator(employment.companyId) ||
                  isAdministrator
                "
                class="mt-4 left"
                actionIcon="$sl-apprentice"
                @click="
                  $nextTick(() => {
                    $router.push({
                      name: 'CompanyApprentices',
                      params: { id: employment.companyId },
                    });
                  })
                "
                >{{ $t("labels.apprentices") }}</ActionButton
              >
            </div>
            <div class="v-step-6">
              <ActionButton
                v-if="
                  isCompanyEducationResponsible(employment.companyId) ||
                  isDistanceEducationAdministrator(employment.companyId) ||
                  isDepartmentAdministrator(employment.companyId) ||
                  isAdministrator
                "
                class="mt-4 left"
                :badge="
                  toApproveForCompany && toApproveForCompany[employment.companyId]
                    ? toApproveForCompany[employment.companyId].length
                    : 0
                "
                actionIcon="$sl-apprentice-application"
                @click="
                  $nextTick(() => {
                    $router.push({
                      name: 'CompanyApplications',
                      params: { id: employment.companyId },
                    });
                  })
                "
                >{{ $t("labels.applications") }}</ActionButton
              >
            </div>
            <div class="v-step-7 v-step-25">
              <ActionButton
                v-if="isCompanyUser(employment.companyId)"
                class="mt-4 left"
                actionIcon="$sl-add-application"
                @click="
                  $nextTick(() => {
                    $router.push({
                      name: 'CreateCompanyApplications',
                      params: { id: employment.companyId, setStep: 0 },
                    });
                  })
                "
                >{{ $t("labels.add-new-applications") }}</ActionButton
              >
            </div>
            <ActionButton
              v-if="isAdministrator || isDepartmentAdministrator(employment.companyId)  || isCompanyEducationResponsible(employment.companyId)"
              class="mt-4"
              actionIcon="$sl-staff"
              @click="
                $nextTick(() => {
                  $router.push({
                    name: 'CompanyEmployees',
                    params: { id: employment.companyId },
                  });
                })
              "
              >{{ $t("labels.staff") }}</ActionButton
            >
            <div class="v-step-5">
              <ActionButton
                v-if="isAdministrator || isDepartmentAdministrator(employment.companyId) || isCompanyEducationResponsible(employment.companyId)"
                class="mt-4 left"
                actionIcon="$sl-permissions"
                @click="
                  $nextTick(() => {
                    $router.push({
                      name: 'CompanyEmployeesPermissions',
                      params: { id: employment.companyId },
                    });
                  })
                "
                >{{ $t("labels.roles") }}</ActionButton
              >
            </div>
            <ActionButton
              v-if="isAdministrator || isDepartmentAdministrator(employment.companyId) || isCompanyEducationResponsible(employment.companyId)"
              class="mt-4"
              actionIcon="$sl-pause"
              @click="
                $nextTick(() => {
                  $router.push({
                    name: 'CompanyPausedPersons',
                    params: { id: employment.companyId },
                  });
                })
              "
              >{{ $t("labels.pause") }}</ActionButton
            >

            <div class="v-step-8">
              <ActionButton
                v-if="
                  isCompanyEducationResponsible(employment.companyId) ||
                  isDistanceEducationAdministrator(employment.companyId) ||
                  isDepartmentAdministrator(employment.companyId) ||
                  isAdministrator
                "
                class="mt-4 left"
                actionIcon="$sl-yua"
                @click="
                  $nextTick(() => {
                    $router.push({
                      name: 'CompanyYUA',
                      params: { id: employment.companyId },
                    });
                  })
                "
                >{{ $t("labels.yua") }}</ActionButton
              >
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </template>

    <template v-if="
          isInstructor(0) == true ||
          isDepartmentAdministrator(0) == true ||
          isAdministrator == true ||
          isDistanceEducationAdministrator(0) == true ||
          isCompanyEducationResponsible(0) == true
        ">
      <ActionButton

        class="pt-0 mt-4 v-step-26"
        actionIcon="$sl-apprentice-application"
        @click="
          $nextTick(() => {
            $router.push({ name: 'ApplicationStart', params: { setStep: 0 } });
          })
        "
        >{{ $t("labels.application") }}</ActionButton
      >

      <p
        class="pt-6"
      >
        {{ $t("welcome.information2") }}
      </p>
    </template>

    <v-tour name="myTour" :steps="steps" :options="tourOptions">
      <template slot-scope="tour">
        <transition name="fade">
          <template v-for="(step, index) of tour.steps">
            <v-step
              v-if="tour.currentStep === index"
              :key="index"
              :step="step"
              :previous-step="tour.previousStep"
              :next-step="tour.nextStep"
              :stop="tour.stop"
              :is-first="tour.isFirst"
              :is-last="tour.isLast"
              :labels="tour.labels"
            >
              <!-- <templatev-if="tour.currentStep > 0 && (tour.currentStep<tour.steps.length - 1)"> -->
              <template>
                <div slot="actions" class="v-step__buttons">
                  <v-icon small @click="tour.stop" class="v-step__close"
                    >$sl-close</v-icon
                  >
                  <button
                    v-if="tour.currentStep == 0"
                    @click="tour.stop"
                    class="v-step__button v-step__button"
                  >
                    {{ $t("tour.stop") }}
                  </button>

                  <button
                    v-if="tour.currentStep > 0"
                    @click="tour.previousStep"
                    class="v-step__button v-step__button"
                  >
                    {{ $t("tour.previous") }}
                  </button>
                  <button
                    v-if="tour.currentStep < tour.steps.length - 1"
                    @click="tour.nextStep"
                    class="v-step__button v-step__button"
                  >
                    {{ $t("tour.next") }}
                  </button>

                  <button
                    v-if="tour.currentStep == tour.steps.length - 1"
                    @click="tour.stop"
                    class="v-step__button v-step__button"
                  >
                    {{ $t("tour.stop") }}
                  </button>
                </div>
              </template>
            </v-step>
          </template>
        </transition>
      </template>
    </v-tour>
    <v-dialog persistent v-model="confirmPhoneModal" max-width="330px">
      <v-card flat>
        <v-icon class="close" @click.prevent="confirmPhoneModal=false">$sl-close</v-icon>
        <h2 class="mt-2">{{ $t('dialog.confirm-modal', {phone: (currentUser.mobilephone) ? $options.filters.phoneNo(currentUser.mobilephone) : $t('dialog.missing'), email: (currentUser.email) ? currentUser.email: $t('dialog.missing')}) }}</h2>

        <v-card flat>
          {{ $t('dialog.confirm-modal-text') }}
        </v-card>
        <div class="d-flex justify-space-between mt-12">
        <ActionButton
          :block="false"
          type="application"
          actionIcon="$sl-edit"
          @click="$nextTick(() => {
            $router.push({
              name: 'PersonAddress'
            })
          })"
        >{{ $t('labels.change') }}</ActionButton>
        <ActionButton
          :block="false"
          actionIcon="$sl-save"
          @click="confirmPhone()"
        >{{$t('labels.yes')}}</ActionButton>
      </div>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ActionButton from "@/components/Common/ActionButton";
import { CompanyRoles, InstructorAbilities } from "@/components/mixins";
import orderBy from 'lodash/orderBy'
import filter from "lodash/filter";
import uniqBy from "lodash/uniqBy";
import get from "lodash/get";
import API from "@/services/api.js";
import ButtonArray from "@/components/Common/ButtonArray";
import EbookList from "@/components/Common/Ebook/EbookList";
import Byn2Import from "@/components/Common/Byn2Import";
import groupBy from "lodash/groupBy";
import MessageBox from "@/components/Common/MessageBox";
import find from "lodash/find";
const SugarDate = require('sugar/date')

// @group Start
// LoggedIn component
export default {
  name: "LoggedIn",

  mixins: [CompanyRoles, InstructorAbilities],

  components: {
    ActionButton,
    ButtonArray,
    EbookList,
    MessageBox,
    Byn2Import
  },
  props: {
    guideStart: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      toApproveForCompany: {},
      confirmPhoneModal: false,
      shouldReadInstructions: false,
      currentUserId: null,
      toConfirm: [],
      firstTime: false,
      showOrderWarning: false,
      tourOptions: {
        useKeyboardNavigation: true,
        highlight: false,
        labels: {
          buttonNext: this.$t("tour.next"),
          buttonPrevious: this.$t("tour.previous"),
          buttonSkip: this.$t("tour.skip"),
          buttonStop: this.$t("tour.stop"),
        },
      },
      steps: [],
      companyApplicationTotal: null
    };
  },
  filters: {
    orgno: function (value) {
      if (!value || value.length < 10) return "";

      return value.substring(0, 6) + "-" + value.substring(6, 10);
    },
  },
  computed: {
    ...mapGetters("currentuser", [
      "currentUser",
      "isLoggedIn",
      "isRegistered",
      "isApprentice",
      "isCompanyUser",
      "isInstructor",
      "isAdministrator",
      "isCompanyEducationResponsible",
      "isDistanceEducationAdministrator",
      "isDepartmentAdministrator",
    ]),
    ...mapGetters("basic", [
      "toApproveByCompanyStatesId",
      "toConfirmByCompanyOrderStateId",
      "basicsIsLoaded",
    ]),

    subTitle(){
      if(!this.currentUser){
        return '';
      }

      const companyNames = orderBy(
        uniqBy(filter(this.currentUser.apprenticeships || [], a => a.manuallyEndedDate === null && !!a.company), 'company.id'),
        o => o.fromDate, 'desc'
      )
        .map(apprenticeship => apprenticeship.company.name || '')

      return `${this.$t('welcome.subTitle')} ${companyNames.join(', ')}`;
    },

    instructorOptions() {
      return [
        {
          user: "isInstructor",
          route: { name: "InstructorEbooks", params: { id: this.currentUser.id } },
          actionIcon: "$sl-ebook",
          title: this.$t("labels.my-book"),
          cssClass: "v-step-22",
        },
        {
          user: "isInstructor",
          route: {
            name: "CompanyInstructorApprentices",
            params: { id: this.currentUserId },
          },
          actionIcon: "$sl-apprentices",
          title: this.$t("labels.my-apprentice"),
          cssClass: "v-step-23",
        },
      ];
    },

    filteredInstructorOptions() {
      const ret = []
      const isInstructorActive = Boolean(this.currentUser?.apprenticeships.length)
      const instructorHasBooks = this.currentUser?.books.length

      if( isInstructorActive )
        ret.push(this.instructorOptions[1])

      if( instructorHasBooks ) 
        ret.push(this.instructorOptions[0])

      return ret
    },

    apprenticeOptions() {
      return [
        {
          user: "isApprentice",
          route: { name: "ApplicationStart", params: { setStep: 0 } },
          actionIcon: "$sl-apprentice-application",
          title: this.$t("labels.application"),
        },
      ];
    },

    hasQualificationTime() {
      return !!this.currentUser?.educations?.some(o => o.qualificationTime)
    },
    
    hasCertificates() {
      return this.currentUser?.educations?.some(o => o.basicEducationCertificate) || !!this.currentUser?.educations?.length
    }
  },

  created() {
    Promise.all([
      this.init(),
      this.getInstructions(),
      this.showConfirmPhone(),
      this.fetchPersonDetails()
    ])
  },

  watch: {
    
    toConfirmByCompanyOrderStateId: {
      handler(id) {
        if ( id > 0 ) this.getCompanyOrders()
      },
      immediate: true
    }
  },

  mounted() {
    this.$scrollToTop();
    this.startTour();
  },

  methods: {
    get,
    find,
    
    ...mapActions("application", ["setCurrentStep"]),
    ...mapActions("currentuser", ["setCurrentUser"]),
    /**
     * @vuese
     * Used to get list of applications that need to be approved and get company distance order for each employements
     * @arg called search criteries as asrgument
     */
    init() {
      //console.log('LoggedIn - init::', this.currentUser)
      if (this.currentUser && this.currentUser.id) {
        this.currentUserId = this.currentUser.id;
        this.initTourSteps();
      }
      if (
        this.currentUserId &&
        (this.isCompanyEducationResponsible(0) ||
          this.isDistanceEducationAdministrator(0) ||
          this.isDepartmentAdministrator(0) ||
          this.isAdministrator || this.isApprentice)
      ) {
        let type = 'received'

        if (this.isApprentice) {
          type = 'own'
        }

        API.listApplications({
          search: "",
          type: type,
          pageSize: 500,
        })
          .then((response) => {
            const acs = this.toApproveByCompanyStatesId;

            const allToApprove = filter(response.data.rows, function (o) {
              return acs.includes(o.stateId);
            });
            this.toApproveForCompany = groupBy(allToApprove, function (o) {
              return o.companyId;
            });

            //- Get total number of company applications apprentice has to approve
            this.companyApplicationTotal = filter(response.data.rows, function(o) { 
              return o.state.state === 'confirmedByCompany' 
            }).length
          })
          .catch((error) => {
            console.log("There was an error:", error);
          });
      }
    },

    getCompanyOrders() {
      let promises = []
      const employments = get(this, 'currentUser.employments', [])

      employments.forEach(employment => {
        const isAdmin = this.isDistanceEducationAdministrator(0) || this.isDepartmentAdministrator(0) || this.isAdministrator

        if( isAdmin && !this.showOrderWarning ) this.getCompanyDistanceOrders(employment.companyId)

        promises.push(
          API.getCompanyOrders(employment.companyId, [this.toConfirmByCompanyOrderStateId])
          .then(({ data }) => {
            const filter = ({ type, stateId }) => ['DistanceOrder', 'ExtensionOrder'].includes(type) && stateId === 1
            return { companyId: employment.companyId, count: data.rows.filter(filter).length }
          })
          .catch((error) => {
            console.log("There was an error:", error.response);
            return 0
          })
        )
      })

      return Promise.all(promises).then(results => {
        this.toConfirm = results.reduce((acc, { companyId, count }) => {
          acc[companyId] = count
          return acc
        }, {})
      })
    },

    async fetchPersonDetails() {
      try {
        if ( !get(this, 'currentUser.id', null) || !get(this, 'currentUser.imitatingUser.userrole.isAdmin', false) ) return
        const { data } = await API.getPerson(this.currentUser.id)
        this.setCurrentUser(data)
      } catch (error) {
        console.log(`Error while fetching person details =>> ${ error }`);
      }
    },
    
    showConfirmPhone(){
      if(new SugarDate.Date(this.$cookies.get('confirmPhoneDate' + this.currentUser.id)).isAfter(new SugarDate.Date().addMonths(-6).raw)==false)
        this.confirmPhoneModal = true
    },
    confirmPhone(){
      //Set/update the cookie with the userId for 6 montsh
      this.$cookies.set("confirmPhoneDate" + this.currentUser.id, new SugarDate.Date().format("{yyyy}-{MM}-{dd}").raw, '6m')
      this.confirmPhoneModal = false
    },
    getInstructions() {
      API.getInstructions()
        .then(({data}) => {
          const commitedDate = data.committedAt
          const lastReadInstructions = this.currentUser.readInstructionsOn
          if (lastReadInstructions) {
            this.shouldReadInstructions = new SugarDate.Date(commitedDate).isAfter(lastReadInstructions).raw
          }
          else
            this.shouldReadInstructions=true
        })
        .catch(error => {
          console.log('Error', error)
        })
    },
    /**
     * @vuese
     * Used to start the Tour, if user is administrator or instructor.
     * The guide will start automatic if it is the first time logged in for admin/instructor.
     */
    startTour() {
      if (this.isAdministrator || this.isInstructor(0)) {
        if (this.currentUser.firstLogin && this.currentUser.firstLogin == true) {
          this.$tours["myTour"].start();
          this.currentUser.firstLogin = false;
          this.setCurrentUser(this.currentUser);
        } else if (this.guideStart == true) {
          this.$tours["myTour"].start();
        }
      }
    },

    getCompanyDistanceOrders(companyId) {
      if (companyId) {
        API.getCompanyDistanceOrders(companyId)
          .then((res) => {
            this.orders = res.data;

            let find= res.data.find(r => (r.stateId === 1 && r.latestApprovalDate && r.profession && r.profession.daysUntilOrderApproval && (r.profession.daysUntilOrderApproval)>0  && (SugarDate.Date(r.latestApprovalDate).daysFromNow() < Number(r.profession.daysUntilOrderApproval)/2 )))

            if(find)
              this.showOrderWarning=true
            if (this.$route.params.distance_order_id) {
              let o = find(this.orders, [
                "id",
                Number(this.$route.params.distance_order_id),
              ]);
              o ? (this.order = o) : (this.order = {});
            }
          })
          .catch((error) => {
            console.log("There was an error:", error.res);
          });
      }
    },
    /**
     * @vuese
     * Used to init the tour steps
     */
    initTourSteps() {
      this.steps = [];
      var userSteps = [];
      if (this.isAdministrator) {
        userSteps = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
      } else if (this.isInstructor) {
        userSteps = [21, 22, 23, 24, 25, 26, 27];
      }
      if (userSteps.length > 0) {
        for (let i = 0; i < userSteps.length; i++) {
          this.steps.push({
            target: ".v-step-" + String(userSteps[i]),
            header: {
              title: this.$t(`tour.title${String(userSteps[i])}`),
            },
            content: this.$t(`tour.text${String(userSteps[i])}`),
            params: {
              placement: "top",
            },
          });
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
